/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelDrsPendingDeduct.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/drs-pending-deduct";

export class AutogenModelDrsPendingDeduct<RowType extends ModelRow> extends Endpoint<RowType, RowDrsPendingDeductFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowDrsPendingDeduct extends ModelRow<RowDrsPendingDeductFields> {
	constructor(values?: Partial<RowDrsPendingDeductFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowDrsPendingDeductFields {
	accrual_glid: string;
	accrual_type: string;
	adjustment_glid: string;
	amount: number;
	amount_c: string;
	amount_d: Date;
	amount_n: number;
	amount_r: number;
	carrier_pro_nbr: string;
	check_number: string;
	company_id: string;
	deduct_code_id: string;
	deduct_code_short_desc: string;
	deduction_type: string;
	descr: string;
	detention_hist_pay_id: string;
	driver_id: string;
	escrow_interest: string;
	extra_pay_id: string;
	gl_accrual_amt: number;
	gl_accrual_amt_c: string;
	gl_accrual_amt_d: Date;
	gl_accrual_amt_n: number;
	gl_accrual_amt_r: number;
	gl_accrual_date: Date;
	glid: string;
	hubtran_approved_inv_date: Date;
	id: string;
	is_intercompany: string;
	loadpay_process_date: Date;
	loadpay_pymt_id: string;
	loadpay_pymt_status: string;
	loadpay_transaction_date: Date;
	loadpay_transaction_num: string;
	manifest_id: string;
	movement_id: string;
	movement_type: string;
	order_id: string;
	payee_exp_used: string;
	payee_id: string;
	post_key: string;
	post_module: string;
	pro_nbr: string;
	process_status: string;
	rate: number;
	ready_to_pay_flag: string;
	recur_deduct_id: string;
	reference_no: string;
	short_desc: string;
	status: string;
	tractor_id: string;
	transaction_date: Date;
	triumphpay_carrierpay_date: Date;
	triumphpay_confirm_code: string;
	triumphpay_process_date: Date;
	triumphpay_pymt_details: string;
	triumphpay_pymt_id: string;
	triumphpay_pymt_status: string;
	triumphpay_quickpay: string;
	triumphpay_transaction_date: Date;
	triumphpay_transaction_num: string;
	units: number;
}

